import { combineReducers } from '@reduxjs/toolkit';
import dialog from './dialogSlice';
import message from './messageSlice';
import settings from './userSettingsDialog'
import addMember from './userManagement'
import viewObject from './viewObjects'
import usagePlanStore from './usagePlanStore'
import viewerHistory from './viewerHistory'
import newsLetter from './newsLetterDialog'


const mainReducers = combineReducers({
	message,
	dialog,
	settings,
	addMember,
	viewObject,
	usagePlanStore,
	viewerHistory,
	newsLetter
});

export default mainReducers;
